import {
  EuiButton,
  EuiButtonEmpty,
  EuiCodeBlock,
  EuiCopy,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiSpacer,
} from "@inscopix/ideas-eui";
import { useState } from "react";

const command = "ideas containers publish";

interface ModalCreateContainerProps {
  onClose: () => void;
}

const ModalCreateContainer = ({ onClose }: ModalCreateContainerProps) => {
  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>Create Container</EuiModalHeaderTitle>
      </EuiModalHeader>

      <EuiModalBody>
        <>
          <p>
            Containers can be created on your local machine using the following
            IDEAS CLI command:
          </p>
          <EuiSpacer size="s" />
          <EuiCodeBlock language="sh" isCopyable fontSize="m">
            {command}
          </EuiCodeBlock>
        </>
      </EuiModalBody>

      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Cancel</EuiButtonEmpty>

        <EuiCopy textToCopy={command}>
          {(copy) => (
            <EuiButton fill onClick={copy}>
              Copy command
            </EuiButton>
          )}
        </EuiCopy>
      </EuiModalFooter>
    </EuiModal>
  );
};

interface ButtonCreateContainerProps {
  filled?: boolean;
}

export const ButtonCreateContainer = ({
  filled = false,
}: ButtonCreateContainerProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const Button = filled ? EuiButton : EuiButtonEmpty;

  return (
    <>
      {isModalVisible && (
        <ModalCreateContainer onClose={() => setIsModalVisible(false)} />
      )}

      <Button
        iconType="plus"
        onClick={() => setIsModalVisible((isVisible) => !isVisible)}
      >
        Create Container
      </Button>
    </>
  );
};
